import React from "react";
import { ReportContextProvider } from "./ReportContext";
import ReportGrid from "./ReportGrid";
const Reports = (props) => {
  return (
    <ReportContextProvider>
      <div style={{ width: "100vw", height: "100vh" }}>
        <ReportGrid ref={props.reportRef} {...props} />
      </div>
    </ReportContextProvider>
  );
};

export default Reports;
